function toggleLanguageSelector() {
    $('.js-language-select').on('click', function() {
        $(this).toggleClass('is-active');
    })
}